import axios from "functions/axios";

export const ReferralApplicationAPI = ({ application, destination_users }) =>
  axios
    .post("application/admin/application/referral/create/", {
      application,
      destination_users,
    })
    .then((res) => res.data);
